<script setup>
import EmailCheck from './EmailCheck.vue'
import ForgotPass from './ForgotPass.vue'
import LogIn from './LogIn.vue'
import Register from './Register.vue'

defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})
const { $auth } = useNuxtApp()
const theme = ref(
  Object.assign(
    {
      container: {
        classes: '',
      },
    },
    $auth.authModalTheme,
  ),
)
</script>
<template>
  <transition name="modal">
    <div
      v-if="visible"
      name="login-modal"
      class="modal-mask"
      @click="$auth.resetAuthModal()"
    >
      <div class="modal-wrapper">
        <div
          :class="'login-modal modal-container ' + theme.container.classes"
          @keyup.esc="$auth.resetAuthModal()"
          @click.stop
        >
          <EmailCheck v-if="$auth.authStep === 'email-check'">
            <template v-if="theme.title" #title>
              <h4>{{ theme.title }}</h4>
            </template>
          </EmailCheck>
          <LogIn v-if="$auth.authStep === 'login'">
            <template v-if="theme.title" #title>
              <h4>{{ theme.title }}</h4>
            </template>
          </LogIn>
          <Register v-if="$auth.authStep === 'register'">
            <template v-if="theme.title" #title>
              <h4>{{ theme.title }}</h4>
            </template>
          </Register>
          <ForgotPass v-if="$auth.authStep === 'forgot-password'" />
        </div>
      </div>
    </div>
  </transition>
</template>
